/**
 * **Lo que el buscador le pide al tablero de Baldosa por la URL** (ronda 20-oct, ola 2 §5), en un solo
 * sitio: `opciones.ts` arma las entradas y `TableroPage` las atiende una vez y las borra.
 */

/** `?accion=`: abre o enfoca algo del tablero; nunca guarda. */
const ACCIONES_DEL_TABLERO = ["programar", "parte", "conciliar", "parametros", "buscar", "hoy"] as const;
export type AccionDelTablero = (typeof ACCIONES_DEL_TABLERO)[number];

/** `?pestana=`: las pestañas de la barra, en su orden (owner, 20-oct: Hoy · Pedidos · Tablero · …). */
export const PESTANAS_DEL_TABLERO = [
  ["hoy", "Hoy"],
  ["pedidos", "Pedidos"],
  ["tablero", "Tablero"],
  ["rendimiento", "Rendimiento"],
  ["empaque", "Empaque y bodega"],
] as const;
export type PestanaDelTablero = (typeof PESTANAS_DEL_TABLERO)[number][0];

export const esAccionDelTablero = (x: string | null): x is AccionDelTablero =>
  (ACCIONES_DEL_TABLERO as readonly (string | null)[]).includes(x);
export const esPestanaDelTablero = (x: string | null): x is PestanaDelTablero =>
  PESTANAS_DEL_TABLERO.some(([k]) => k === x);
